import { mainTypes } from ".";

export function closeError(params, cb) {
    return {
        type: mainTypes.ERROR,
        params,
        cb,
    }
}

export function changeLanguage(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.CHANGE_LANGUAGE,
            params,
            resolve,
            reject
        })
    })
}

export function checkLanguage() {
    return {
        type: mainTypes.CHECK_LANGUAGE,
    }
}

export function LOADING(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.LOADING,
            params,
            resolve,
            reject
        })
    })
}

export function API_spCallServer(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.API_spCallServer,
            params,
            resolve,
            reject
        })
    })
}

/**
 * ✅ SAFE VERSION - Tự động xử lý lỗi, component KHÔNG CẦN try-catch
 * Wrapper cho API_spCallServer với error handling tự động
 * 
 * @param {Object} params - API parameters
 * @param {Function} dispatch - Redux dispatch
 * @param {Object} options - Options for error handling
 * @param {boolean} options.showError - Hiển thị error alert (default: true) - Saga đã hiển thị rồi
 * @param {boolean} options.returnNull - Trả về null khi lỗi thay vì throw (default: true)
 * @param {string} options.customErrorMessage - Custom error message
 * @returns {Promise<any|null>} - Result hoặc null nếu lỗi
 * 
 * @example
 * // CÁCH DÙNG: Giống hệt API_spCallServer, nhưng KHÔNG CẦN try-catch
 * const result = await API_spCallServerSafe(params, dispatch);
 * if (result && result.resultCode === 0) {
 *   Alertsuccess("Thành công!");
 * }
 * // Nếu lỗi (403, 500...) => result = null, đã tự động hiển thị Alert
 */
export function API_spCallServerSafe(params, dispatch, options = {}) {
    const { returnNull = true } = options;
    
    return new Promise((resolve) => {
        dispatch({
            type: mainTypes.API_spCallServer,
            params,
            resolve: (data) => resolve(data), // Success -> trả data
            reject: (error) => {
                // Error -> Saga đã hiển thị Alert rồi
                // Chỉ cần trả null để component tiếp tục chạy
                if (returnNull) {
                    resolve(null);
                } else {
                    resolve(undefined);
                }
            }
        })
    })
}

export function API_spCallServerNoLoading(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.API_spCallServerNoLoading,
            params,
            resolve,
            reject
        })
    })
}

/**
 * ✅ SAFE VERSION - NoLoading
 */
export function API_spCallServerNoLoadingSafe(params, dispatch, options = {}) {
    const { returnNull = true } = options;
    
    return new Promise((resolve) => {
        dispatch({
            type: mainTypes.API_spCallServerNoLoading,
            params,
            resolve: (data) => resolve(data),
            reject: () => resolve(returnNull ? null : undefined)
        })
    })
}

export function API_spCallServerNoSQL(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.API_spCallServerNoSQL,
            params,
            resolve,
            reject
        })
    })
}
export function API_spCallServerNoSQL_App(params, dispatch) {
    return new Promise((resolve, reject) => {
        dispatch({
            type: mainTypes.API_spCallServerNoSQL_App,
            params,
            resolve,
            reject
        })
    })
}

export function EncryptString(params, dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: mainTypes.EncryptString,
        params,
        resolve,
        reject,
      });
    });
  }

  
  export function DecryptString(params, dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: mainTypes.DecryptString,
        params,
        resolve,
        reject,
      });
    });
  }